import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material';

import { themeLight } from '../helpers/themeSystem';

export const ColorModeProvider = ({ children }) => {
    const theme = createTheme(themeLight);

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default ColorModeProvider;